module.exports = __webpack_public_path__ + "img/product_72.e69b0d5.webp";